import { LocalDate } from '@js-joda/core';

export const getLocalDateToday = (): LocalDate => {
   return LocalDate.now();
};
